var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { api } from 'helpers/Api';
import { action, observable } from 'mobx';
import { Log } from './Model';
var LogStore = /** @class */ (function () {
    function LogStore() {
        var _this = this;
        this.data = [];
        this.loaded = false;
        this.readLoginOut = function (user_id) {
            _this.loaded = false;
            return api.get("user/logs/".concat(user_id, "?action=loginout")).then(function (value) {
                _this.loaded = true;
                return value;
            });
        };
        this.set = function (values) {
            _this.loaded = true;
            _this.data = values.map(function (value) { return new Log(value); });
            return _this.data;
        };
    }
    LogStore.prototype.read = function () {
        this.loaded = false;
        return api.get('logs').then(this.set);
    };
    __decorate([
        observable
    ], LogStore.prototype, "data", void 0);
    __decorate([
        observable
    ], LogStore.prototype, "loaded", void 0);
    __decorate([
        action
    ], LogStore.prototype, "read", null);
    __decorate([
        action
    ], LogStore.prototype, "readLoginOut", void 0);
    __decorate([
        action
    ], LogStore.prototype, "set", void 0);
    return LogStore;
}());
export default LogStore;



//////////////////
// WEBPACK FOOTER
// ./src/modules/Logs/Store.ts
// module id = 723
// module chunks = 0